$('ul.nav li:nth-child(3) a').addClass('active');